export const AnchorClass = 'messages-anchor'
export const MessagesContainerClass = 'chat-messages'
